<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('EquipmentRenewal.type')">
                    <el-select
                      v-model="formInline.category"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in categoryList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('common.num')">
                    <el-input
                      size="mini"
                      v-model="formInline.deviceNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('EquipmentRenewal.feeType')">
                    <el-select
                      v-model="formInline.chargeType"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in chargeTypeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('EquipmentRenewal.chargingStatus')">
                    <el-select
                      v-model="formInline.chargeState"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in chargeStateList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('EquipmentRenewal.feeRemarks')">
                    <el-input
                      size="mini"
                      v-model="formInline.chargeRemark"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTRENEWAL_CHANGEOFCHARGINGTYPE')"
                  type="text"
                  :disabled="selected.length == 0"
                  @click="changeType"
                  >{{ $t("EquipmentRenewal.changeOfChargingType") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTRENEWAL_BATCHRENEWAL')"
                  type="text"
                  @click="ImportRenewal"
                  >{{ $t("EquipmentRenewal.batchRenewal") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTRENEWAL_BATCHSCRAP')"
                  type="text"
                  @click="ImportScrap"
                  >{{ $t("EquipmentRenewal.batchScrapping") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTRENEWAL_RENEWALTEMPLATE')"
                  type="text"
                  @click="TemplateDown"
                  >{{ $t("EquipmentRenewal.RenewalTemplateDownload") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTRENEWAL_SCRAPTEMPLATE')"
                  type="text"
                  @click="scrapTemplateDown"
                  >{{ $t("EquipmentRenewal.scrapTemplateDownload") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTRENEWAL_DOWN')"
                  type="text"
                  @click="downCar"
                  >{{ $t("common.btn.download") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="carDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            :label="$t('EquipmentRenewal.type') + ':'"
            :label-width="formLabelWidth"
            prop="category"
          >
            <el-select
              v-model="form.category"
              :placeholder="$t('common.choseTip')"
            >
              <el-option :label="$t('common.carId')" value="0"></el-option>
              <el-option
                :label="$t('common.externalNumber')"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="this.btnType == 'add'"
            :label="$t('EquipmentRenewal.uploadFiles') + ':'"
            :label-width="formLabelWidth"
            prop="upload"
          >
            <input @change="uploadFile()" id="uploadDom" type="file" style="display: none;" />
            <el-button type="primary" size="small" @click="triggerFileUpload()">{{ $t("common.btn.uploadFile") }}</el-button>
          </el-form-item>
          <el-form-item
            v-if="this.btnType == 'edit'"
            :label="$t('EquipmentRenewal.uploadFiles') + ':'"
            :label-width="formLabelWidth"
            prop="uploads"
          >
            <input @change="uploadFiles()" id="uploadDoms" type="file" style="display: none;" />
            <el-button type="primary" size="small" @click="triggerFileUploads()">{{ $t("common.btn.uploadFile") }}</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeChangeDia"
        class="addDialong"
        :title="$t('VehicleManagement.btn.replaceTerminal')"
        :visible.sync="dialogChangeFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="ChangeRules" ref="ChangeForm" :model="ChangeForm">
          <el-form-item
            :label="$t('EquipmentRenewal.feeType') + ':'"
            :label-width="LabelWidth"
            prop="chargeType"
          >
            <el-select
              v-model="ChangeForm.chargeType"
              :placeholder="$t('common.choseTip')"
            >
              <el-option
                :label="$t('EquipmentRenewal.charge')"
                value="0"
              ></el-option>
              <el-option
                :label="$t('EquipmentRenewal.noCharge')"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="chargeRemark"
            :label="$t('EquipmentRenewal.feeRemarks') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              size="small"
              v-model="ChangeForm.chargeRemark"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="chargeStandard"
            :label="$t('EquipmentRenewal.feeStandards') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              size="small"
              v-model="ChangeForm.chargeStandard"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleChange('ChangeForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitChangeForm('ChangeForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog>
      <!-- <el-dialog
        width="620px"
        :before-close="closeBatchDia"
        :title="$t('common.btn.batchUpload')"
        :visible.sync="dialogBatchFormVisible"
        class="batchDialong"
        :close-on-click-modal="false"
      >
        <div class="right-file">
          <el-button type="text" size="mini" @click="TemplateFile()">{{
            $t("common.btn.downloadModelFile")
          }}</el-button>
        </div>
        <div class="upload-file">
          <img src="../../../assets/images/upload.png" />
          <div>{{ $t("common.btn.clickUploadFile") }}</div>
          <input @change="uploadCar()" id="uploadDom" type="file" />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogBatchFormVisible = false" class="btn-del">{{
            $t("common.btn.cancel")
          }}</el-button>
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import EquipmentRenewal from "./EquipmentRenewal.js";
export default EquipmentRenewal;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
